import React, { useEffect, useState } from 'react'
import Picture from '../../components/Picture'
import './ClientLogosSlider.scss'

const ClientLogosSlider = ({ className = '', hideHeader = false }) => {
  const [shouldLoadLogos, setShouldLoadLogos] = useState(false)

  const logos = [
    {
      src: '/images/site/customers/alva-horizontal.png',
      alt: 'Alva',
      webp: '/images/site/customers/alva-horizontal.webp'
    },
    {
      src: '/images/site/customers/anasol-horizontal.png',
      alt: 'Anasol',
      webp: '/images/site/customers/anasol-horizontal.webp'
    },
    {
      src: '/images/site/customers/baggio-horizontal.png',
      alt: 'Baggio',
      webp: '/images/site/customers/baggio-horizontal.webp'
    },
    {
      src: '/images/site/customers/berwanger-horizontal.png',
      alt: 'Berwanger',
      webp: '/images/site/customers/berwanger-horizontal.webp'
    },
    {
      src: '/images/site/customers/beyoung-horizontal.png',
      alt: 'Beyoung',
      webp: '/images/site/customers/beyoung-horizontal.webp'
    },
    {
      src: '/images/site/customers/buffalo-horizontal.png',
      alt: 'Buffalo',
      webp: '/images/site/customers/buffalo-horizontal.webp'
    },
    {
      src: '/images/site/customers/cicero-horizontal.png',
      alt: 'Cicero',
      webp: '/images/site/customers/cicero-horizontal.webp'
    },
    {
      src: '/images/site/customers/dobro-horizontal.png',
      alt: 'Dobro',
      webp: '/images/site/customers/dobro-horizontal.webp'
    },
    {
      src: '/images/site/customers/gelopar-horizontal.png',
      alt: 'Gelopar',
      webp: '/images/site/customers/gelopar-horizontal.webp'
    },
    {
      src: '/images/site/customers/herbia-horizontal.png',
      alt: 'Herbia',
      webp: '/images/site/customers/herbia-horizontal.webp'
    },
    {
      src: '/images/site/customers/hey-mu-horizontal.png',
      alt: 'Hey Mu',
      webp: '/images/site/customers/hey-mu-horizontal.webp'
    },
    {
      src: '/images/site/customers/hprime-horizontal.png',
      alt: 'HPrime',
      webp: '/images/site/customers/hprime-horizontal.webp'
    },
    {
      src: '/images/site/customers/keune-horizontal.png',
      alt: 'Keune',
      webp: '/images/site/customers/keune-horizontal.webp'
    },
    {
      src: '/images/site/customers/la-ganexa-horizontal.png',
      alt: 'La Ganexa',
      webp: '/images/site/customers/la-ganexa-horizontal.webp'
    },
    {
      src: '/images/site/customers/labotrat-horizontal.png',
      alt: 'Labotrat',
      webp: '/images/site/customers/labotrat-horizontal.webp'
    },
    {
      src: '/images/site/customers/maped-horizontal.png',
      alt: 'Maped',
      webp: '/images/site/customers/maped-horizontal.webp'
    },
    {
      src: '/images/site/customers/mbled-horizontal.png',
      alt: 'MBled',
      webp: '/images/site/customers/mbled-horizontal.webp'
    },
    {
      src: '/images/site/customers/mili-horizontal.png',
      alt: 'Mili',
      webp: '/images/site/customers/mili-horizontal.webp'
    },
    {
      src: '/images/site/customers/mtx-horizontal.png',
      alt: 'MTX',
      webp: '/images/site/customers/mtx-horizontal.webp'
    },
    {
      src: '/images/site/customers/oakberry-horizontal.png',
      alt: 'Oakberry',
      webp: '/images/site/customers/oakberry-horizontal.webp'
    },
    {
      src: '/images/site/customers/tagima-horizontal.png',
      alt: 'Tagima',
      webp: '/images/site/customers/tagima-horizontal.webp'
    }
  ]

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setShouldLoadLogos(true), 0)

    return () => window.clearTimeout(timeoutId)
  }, [])

  const renderLogo = (logo, key) => (
    <div key={key} className="logo-item">
      <Picture
        src={logo.src}
        alt={logo.alt}
        mobileSrc={logo.webp}
        className="logo-image"
        loading="lazy"
        decoding="async"
      />
    </div>
  )

  return (
    <div className={`client-logos-slider-wrapper ${className}`}>
      {!hideHeader && <p className="slider-header"><b>+ 9.000</b> empresas confiam na Mercos</p>}
      <div className="client-logos-slider">
        <div className="slider-track">
          {shouldLoadLogos && logos.map((logo, index) => renderLogo(logo, `logo-${index}`))}
          {shouldLoadLogos && logos.map((logo, index) => renderLogo(logo, `logo-duplicate-${index}`))}
        </div>
      </div>
    </div>
  )
}

export default ClientLogosSlider



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/ClientLogosSlider.jsx